import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { BreakpointsService } from '@core/services/breakpoints/breakpoints.service';
import { CustomMetaService } from '@core/services/meta-service/meta.service';
import { ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  templateUrl: './cej-v2.component.html',
  styleUrls: ['./cej-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CejV2Component implements OnInit, OnDestroy {
  openContactDialog$ = new BehaviorSubject<boolean>(false);
  readonly cejFormId = 'cejForm';

  constructor(
    private readonly metaService: CustomMetaService,
    private readonly scrollToService: ScrollToService,
    private readonly breakpointsService: BreakpointsService
  ) {}

  ngOnInit(): void {
    this.metaService.updateForSeo({
      title: "Le Contrat d'Engagement Jeune (CEJ)",
      description:
        "Le Contrat d'Engagement Jeune, ou CEJ, est un parcours personnalisé de 6 à 12 mois permettant à tous les jeunes de définir un projet professionnel solide et durable",
    });
  }

  ngOnDestroy(): void {
    this.metaService.restoreForSeo();
  }

  scrollTo(): void {
    this.breakpointsService.isMobileOrTablet$.pipe(take(1)).subscribe((isMobileOrTablet) => {
      this.scrollToService.scrollTo({ target: this.cejFormId, offset: isMobileOrTablet ? -50 : -100 });
    });
  }
}
